import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Watch} from 'vue-property-decorator';
import EdInputModel from '@/models/ed-input.model';
import {maxLength, minLength, required} from 'vuelidate/lib/validators';

@Component({
  name: 'ed-table-modal'
})
export default class EdTableModal extends Vue {

    private rowText = EdInputModel('rowText',
        1,
        {required, minLength: minLength(1), maxLength: maxLength(30)});
    private columnText = EdInputModel('columnText',
        1,
        {required, minLength: minLength(1), maxLength: maxLength(30)});

    private isValid: boolean = false;

    get isFormValid() {
        return this.isValid;
    }

    @Emit('insertTable')
    private insertTable() {   
        return { rows: this.rowText.value, columns: this.columnText.value }
    }

    @Emit('cancelTable')
    private cancelTable() {
        return false;
    }

    @Watch('rowText.value')
    @Watch('columnText.value')
    validateModels() {
        this.isValid = this.rowText.valid && this.columnText.valid;
    }
}